import { Loader2 } from 'lucide-react';
import { DashboardLayout } from '@/ui/layout/DashboardLayout';

interface PageLoaderProps {
  /** Wrap in DashboardLayout (default: true) */
  withLayout?: boolean;
}

export const PageLoader = ({ withLayout = true }: PageLoaderProps) => {
  const spinner = (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );

  if (withLayout) {
    return <DashboardLayout>{spinner}</DashboardLayout>;
  }

  return spinner;
};
